export const DEFAULT_TABLE_HEADER_COUNT = 2;
export const CATALOG_VARIANT_TABLE = 'table';
export const CATALOG_VARIANT_TILE = 'tile';

export const EXPANDED_ATTRIBUTE = 'expanded';

export const USER_SELECT_NONE_CLASS = 'user-select-none';
export const AVAILABLE_COUNT_PROP = 'AVAILABLE';
